import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  loading: {
    color: theme.partnerComponents.input.icon,
    backgroundColor: 'transparent !important',
    marginRight: 10,
  },
  check: {
    color: theme.partnerComponents.input.icon,
  },
  adornment: {
    color: theme.partnerComponents.input.icon,
  },
  root: {
    '& .MuiFormLabel-root': {
      color: theme.appColors.darkGray,
      fontSize: '14px !Important',
      fontWeight: 300,
      fontFamily: theme.typography.inter.fontFamily,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.85) !important',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontSize: '12px !Important',
      transform: 'translate(16px, -6px) scale(0.95)',
    },
    '& .MuiInputLabel-outlined': {
      backgroundColor: 'transparent!important',
    },
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
      fontFamily: theme.typography.inter.fontFamily,
      letterSpacing: '-0.13px',
      lineHeight: '24px',
      fontSize: 14,
      backgroundColor: theme.appColors.white,
      fontWeight: 300,
    },
    '& .MuiFormHelperText-root': {
      fontFamily: 'Inter',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      backgroundColor: theme.appColors.white,
    },
  },
  notchedOutline: {
    borderWidth: '1px',
    borderColor: theme.partnerComponents.input.border,
  },
}));
